document.querySelectorAll('.wd-pillow-addon-checkbox-4471').forEach(function (checkbox) {
  checkbox.addEventListener('change', function () {
    var form = checkbox.closest('form[action*="/cart/add"]');
    if (!form) return;
    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    variantInput.value = checkbox.checked
      ? checkbox.dataset.addonVariantId
      : checkbox.dataset.baseVariantId;
  });
});